// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"2d3aa935","300":"2d3aa935","572":"2c90259a"}[chunkId] + ".chunk.css";
};